<template>
  <div v-if="errorMessages?.length || failedFolders?.length || failedFiles?.length" id="errorMessages">
    <h2>{{ headline }}</h2>
    <pre v-if="errorMessages.length>0"><template v-for="message in reversedErrorMessages">{{ message }}</template></pre>
    <div v-for="failedFolder in failedFolders">
      {{ failedFolder.error }}
    </div>
    <div v-for="failedFile in failedFiles">
      <div>
        {{ failedFile.foldername }}/{{ failedFile.filename }}<br />
        <small>
          {{ failedFile.error }}
        </small>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        props: {
            headline: null,
            errorMessages: null,
            failedFolders: null,
            failedFiles: null,
        },
        computed: {
            reversedErrorMessages: function() {
                return this.errorMessages.slice().reverse();
            }
        }

    };
</script>

<style scoped lang="less">
    #errorMessages {
        pre {
            max-height: 50vh;
            overflow-y: scroll;
        }
        div {
            color: #D8000C;
            background-color: #FFD2D2;
            padding: 12px;
            margin: 10px 0;
        }
    }
</style>
